// extracted by mini-css-extract-plugin
export default {"cls1":"R1Y2bPW_25c2GlNj6Xns","cls2":"D7sTmnMovJzDU2gkkIJR R1Y2bPW_25c2GlNj6Xns"};